import { userConstants } from '../constants';

export const registerReducer = (state = {}, action) => {
    switch(action.type) {
        case userConstants.REGISTER_REQUEST:
            // delete password for security
            if(action.payload.hasOwnProperty('password')) delete action.payload.password;

            return {
                ...state,
                data: Object.assign(state.data || {}, action.payload),
                process: true
            };

        case userConstants.REGISTER_SUCCESS:
            return {
                ...state,
                error: false,
                errorEmail: false,
                process: false
            };

        case userConstants.REGISTER_FAILURE:
            return {
                ...state,
                error: true,
                process: false
            };

        case userConstants.REGISTER_DUPLICATE_EMAIL:
            return {
                ...state,
                error: true,
                errorEmail: true,
                process: false
            };

        default:
            return state;
    }
}

export default registerReducer;


// WEBPACK FOOTER //
// ./src/reducers/register.js